(() => {
  const one = (selector, root = document) => (root || document).querySelector(selector);
  const all = (selector, root = document) => [...(root || document).querySelectorAll(selector)];
  const body = document.body;
  const setOpen = (element, open) => {
    if (!element) return;
    element.classList.toggle('is-open', open);
    element.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('no-scroll', open);
  };

  const header = one('[data-header]');
  const mobileMenu = one('[data-mobile-menu]');
  one('[data-menu-open]')?.addEventListener('click', () => setOpen(mobileMenu, true));
  all('[data-menu-close]').forEach((button) => button.addEventListener('click', () => setOpen(mobileMenu, false)));

  // Desktop mega menu: the target opens panels by click, with one panel open at a time.
  const navItems = all('[data-nav-item]', header);
  const closeAllMega = () => navItems.forEach((item) => {
    item.classList.remove('is-open');
    one('[data-nav-trigger]', item)?.setAttribute('aria-expanded', 'false');
    one('.mega-menu', item)?.setAttribute('aria-hidden', 'true');
  });
  navItems.forEach((item) => {
    const trigger = one('[data-nav-trigger]', item);
    const toggle = (event) => {
      event.stopPropagation();
      const shouldOpen = !item.classList.contains('is-open');
      closeAllMega();
      if (shouldOpen) {
        item.classList.add('is-open');
        trigger?.setAttribute('aria-expanded', 'true');
        one('.mega-menu', item)?.setAttribute('aria-hidden', 'false');
        header.classList.add('mega-open');
      } else {
        header.classList.remove('mega-open');
      }
    };
    trigger?.addEventListener('click', toggle);
  });
  document.addEventListener('click', (event) => {
    if (!header?.contains(event.target)) {
      closeAllMega();
      header?.classList.remove('mega-open');
    }
  });
  header?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllMega();
      header.classList.remove('mega-open');
    }
  });

  // Mobile nested accordions.
  all('[data-mobile-toggle]', mobileMenu).forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const branch = toggle.closest('[data-mobile-branch]');
      const isOpen = branch.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  });

  const announcements = ['Free Standard Shipping On Orders $99+', 'Easy U.S. Returns & Exchanges', 'Guaranteed for Good™'];
  let announcementIndex = 0;
  const announcementText = one('[data-announcement-text]');
  const showAnnouncement = (delta) => {
    announcementIndex = (announcementIndex + delta + announcements.length) % announcements.length;
    if (announcementText) announcementText.textContent = announcements[announcementIndex];
  };
  one('[data-announcement-prev]')?.addEventListener('click', () => showAnnouncement(-1));
  one('[data-announcement-next]')?.addEventListener('click', () => showAnnouncement(1));

  const country = one('[data-country-modal]');
  one('[data-country-open]')?.addEventListener('click', () => setOpen(country, true));
  all('[data-country-close]').forEach((button) => button.addEventListener('click', () => setOpen(country, false)));

  all('[data-accordion]').forEach((item) => {
    one('button', item)?.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      one('button', item)?.setAttribute('aria-expanded', String(open));
    });
  });
  all('[data-footer-group]').forEach((group) => one('.footer-heading', group)?.addEventListener('click', (event) => {
    if (!matchMedia('(max-width: 900px)').matches) return;
    const open = group.classList.toggle('is-open');
    event.currentTarget.setAttribute('aria-expanded', String(open));
  }));

  const filterDrawer = one('[data-filter-drawer]');
  const filterBackdrop = one('.filter-backdrop');
  const setFiltersOpen = (open) => {
    if (!filterDrawer) return;
    filterDrawer.classList.toggle('is-open', open);
    filterDrawer.setAttribute('aria-hidden', String(!open && matchMedia('(max-width: 900px)').matches));
    filterBackdrop?.classList.toggle('is-open', open);
    body.classList.toggle('no-scroll', open);
  };
  one('[data-filter-open]')?.addEventListener('click', () => setFiltersOpen(true));
  all('[data-filter-close]').forEach((button) => button.addEventListener('click', () => setFiltersOpen(false)));
  one('[data-sort-select]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.currentTarget.value);
    window.location.assign(url.toString());
  });

  all('[data-slider]').forEach((slider) => {
    const track = one('[data-slider-track]', slider);
    const move = (direction) => track?.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    one('[data-slide-prev]', slider)?.addEventListener('click', () => move(-1));
    one('[data-slide-next]', slider)?.addEventListener('click', () => move(1));
  });

  const homeProducts = one('[data-home-products]');
  const homeProductsTrack = one('[data-home-products-track]', homeProducts);
  const moveHomeProducts = (direction) => homeProductsTrack?.scrollBy({ left: direction * homeProductsTrack.clientWidth * .8, behavior: 'smooth' });
  one('[data-home-products-prev]', homeProducts)?.addEventListener('click', () => moveHomeProducts(-1));
  one('[data-home-products-next]', homeProducts)?.addEventListener('click', () => moveHomeProducts(1));

  all('[data-card-swatch]').forEach((swatch) => swatch.addEventListener('click', () => {
    const card = swatch.closest('.product-card');
    if (!card) return;
    all('[data-card-swatch]', card).forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    if (swatch.dataset.imageSrc) {
      const image = one('[data-card-primary] img', card);
      const hoverImage = one('[data-card-hover] img', card);
      if (image) {
        image.src = swatch.dataset.imageSrc;
        image.removeAttribute('srcset');
      }
      if (hoverImage) {
        hoverImage.src = swatch.dataset.imageSrc;
        hoverImage.removeAttribute('srcset');
      }
    }
    if (swatch.dataset.price) {
      const price = one('[data-card-price]', card);
      if (price) price.textContent = swatch.dataset.price;
    }
    if (swatch.dataset.url) all('[data-card-link]', card).forEach((link) => { link.href = swatch.dataset.url; });
  }));

  all('[data-variant-option]').forEach((option) => option.addEventListener('click', () => {
    const group = option.closest('[data-variant-group]');
    all('[data-variant-option]', group).forEach((item) => item.classList.remove('is-selected'));
    option.classList.add('is-selected');
    const select = one('select', group);
    if (select) {
      select.value = option.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }));

  const productForm = one('[data-product-form]');
  const variantsNode = one('[data-product-variants]');
  if (productForm && variantsNode) {
    const variants = JSON.parse(variantsNode.textContent);
    const selects = all('[data-option-select]', productForm);
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2
    }).format(cents / 100);
    const syncVariant = () => {
      const values = selects.map((select) => select.value);
      const variant = variants.find((entry) => entry.options.every((value, index) => value === values[index]));
      const productError = one('[data-product-error]', productForm);
      if (productError) productError.hidden = true;
      if (!variant) {
        one('[name="id"]', productForm).value = '';
        [one('[type="submit"]', productForm), one('[data-sticky-product-submit]')].filter(Boolean).forEach((button) => {
          button.disabled = true;
          button.textContent = productForm.dataset.unavailableLabel;
        });
        return;
      }
      one('[name="id"]', productForm).value = variant.id;
      const submit = one('[type="submit"]', productForm);
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? `Add to Cart (${formatMoney(variant.price)})` : 'Out of Stock';
      const price = one('[data-product-price]');
      if (price) price.textContent = formatMoney(variant.price);
      const stickyPrice = one('[data-sticky-product-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      const stickySubmit = one('[data-sticky-product-submit]');
      if (stickySubmit) {
        stickySubmit.disabled = !variant.available;
        stickySubmit.textContent = variant.available ? 'Add to Cart' : 'Out of Stock';
      }
      const comparePrice = one('[data-product-compare-price]');
      const priceGroup = one('[data-product-price-group]');
      const savings = one('[data-product-savings]');
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (comparePrice) {
        comparePrice.hidden = !onSale;
        comparePrice.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      priceGroup?.classList.toggle('is-on-sale', Boolean(onSale));
      if (savings) {
        const savingsAmount = onSale ? variant.compare_at_price - variant.price : 0;
        const discountPercent = onSale ? Math.round((savingsAmount / variant.compare_at_price) * 100) : 0;
        savings.hidden = !onSale;
        savings.textContent = onSale ? `Save ${formatMoney(savingsAmount)} (${discountPercent}%)` : '';
      }
      all('[data-variant-group]', productForm).forEach((group, index) => {
        const value = values[index];
        const label = one('legend span', group);
        if (label) label.textContent = value;
        all('[data-variant-option]', group).forEach((button) => {
          const selected = button.dataset.value === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      });
      const colorGroup = all('[data-variant-group]', productForm).find((group) => /colou?r/i.test(one('legend', group)?.textContent || ''));
      const selectedColor = colorGroup ? one('[data-option-select]', colorGroup)?.value : '';
      const galleryItems = all('[data-product-media]');
      if (selectedColor && galleryItems.some((item) => item.dataset.mediaColor === selectedColor)) {
        galleryItems.forEach((item) => { item.hidden = Boolean(item.dataset.mediaColor && item.dataset.mediaColor !== selectedColor); });
      } else {
        galleryItems.forEach((item) => { item.hidden = false; });
      }
      if (variant.featured_media?.id) {
        const media = one(`[data-product-media="${variant.featured_media.id}"]`);
        media?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    selects.forEach((select) => select.addEventListener('change', syncVariant));
    syncVariant();
  }

  const swatchColors = {
    abyss: '#17475d', acai: '#7b3459', black: '#232629', blue: '#397a91', carbon: '#4a4a47', chalk: '#e8e4da',
    crimson: '#b3263b', fatigue: '#6e7052', fig: '#8a596d', indigo: '#344765', juniper: '#57745f', lake: '#438ca2',
    mineral: '#8d9b92', moonbeam: '#d9d5c8', ocean: '#245a70', oak: '#6f6845', pink: '#d8919f', spicy: '#d44b32',
    spruce: '#42665f', whiskey: '#946338', white: '#efefeb', woods: '#5e5b45', yellow: '#e6b72d'
  };
  all('[data-swatch-name]').forEach((swatch) => {
    if (swatch.style.getPropertyValue('--swatch-image') || swatch.style.getPropertyValue('--swatch-color')) return;
    const names = swatch.dataset.swatchName.toLowerCase().split(/\s*[/&+]\s*|\s+and\s+/);
    const colors = names.map((name) => Object.entries(swatchColors).find(([key]) => name.includes(key))?.[1]).filter(Boolean);
    if (!colors.length) return;
    if (colors.length > 1) swatch.style.setProperty('--swatch-gradient', `linear-gradient(135deg, ${colors[0]} 0 50%, ${colors[1]} 50% 100%)`);
    else swatch.style.setProperty('--swatch-color', colors[0]);
  });

  one('[data-sticky-product-submit]')?.addEventListener('click', () => productForm?.requestSubmit());
  const stickyProductBar = one('[data-sticky-product-bar]');
  if (stickyProductBar && productForm) {
    const observer = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && window.scrollY > productForm.offsetTop;
      stickyProductBar.classList.toggle('is-visible', visible);
      stickyProductBar.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0 });
    observer.observe(productForm);
  }

  const gallery = one('.product-gallery');
  if (gallery) gallery.addEventListener('scroll', () => {
    const items = all('.product-gallery__item', gallery);
    if (!items.length) return;
    const current = items.reduce((best, item, index) => Math.abs(item.offsetLeft - gallery.scrollLeft) < Math.abs(items[best].offsetLeft - gallery.scrollLeft) ? index : best, 0);
    const counter = one('[data-gallery-current]', gallery);
    if (counter) counter.textContent = current + 1;
  }, { passive: true });

  const privacyBanner = one('[data-privacy-banner]');
  if (privacyBanner && !localStorage.getItem('cotopaxi-privacy-choice')) privacyBanner.hidden = false;
  all('[data-privacy-dismiss], [data-privacy-accept]').forEach((button) => button.addEventListener('click', () => {
    localStorage.setItem('cotopaxi-privacy-choice', button.hasAttribute('data-privacy-accept') ? 'accepted' : 'dismissed');
    if (privacyBanner) privacyBanner.hidden = true;
  }));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    window.CotopaxiCart?.close();
    setOpen(country, false);
    setOpen(mobileMenu, false);
  });
})();
